import script from "./bt-device-info.vue?vue&type=script&setup=true&lang=js"
export * from "./bt-device-info.vue?vue&type=script&setup=true&lang=js"

import "./bt-device-info.vue?vue&type=style&index=0&id=876c6d36&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-876c6d36"]])

export default __exports__